import { render, staticRenderFns } from "./ItemMenu.vue?vue&type=template&id=529d0c2c&"
import script from "./ItemMenu.vue?vue&type=script&lang=ts&"
export * from "./ItemMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports